import * as React from 'react';
import { memo } from 'react';

const SvgDownloadCloud = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 26 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m9 18 4 4 4-4M13 13v9", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M21.88 19.09A5 5 0 0 0 19 10h-1.26A8 8 0 1 0 4 17.29", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgDownloadCloud);

export { Memo as default };
